module.exports = __webpack_public_path__ + "static/img/qrcode.6fa98f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/qrcode.png
// module id = Nm7F
// module chunks = 62